export const NavMainOpenStateClassName = `nav-main__open`
export const BurgerActiveClassName = `is-active`
export const BurgerInvertedClassName = `is-inverted`
export const SiteHeaderInvertedStateClassName = `site-header__inverted`
export const SiteHeaderHiddenStateClassName = `site-header__hidden`
